import {Col, Container, Row} from "react-awesome-styled-grid";
import {Img, Text} from "../../design";
import ErrorIcon from "../../assets/imgs/error.svg";
import React from "react";

type Props = {
  header: string,
  message: string
}

const PaymentError = (props:Props) => {
  const { header, message } = props;
  return (
    <Container className="w-100 p-0 text-break">
      <Row id="error" className="mr-0">
        <Col xs={1} sm={1} md={1} xl={1} className="d-none d-lg-flex px-2" noGutter style={{alignItems: "center"}}>
          <Img src={ErrorIcon} a height="60px" width="38px"/>
        </Col>
        <Col md={7} noGutter className="px-2">
          <Text marginBottom="0px" color="#ff1e1e" fontWeight="600">
           {header || "Error occurred while processing the payment."}
          </Text>
          <Text color="#ff1e1e">
            {message}
          </Text>
        </Col>
      </Row>
    </Container>
  )
};

export default PaymentError;
